import React, { useState } from 'react';

type Props = {
  title: string;
  icon?: React.ReactNode;
  rightSlot?: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
};

const HelpAccordion: React.FC<Props> = ({ title, icon, rightSlot, defaultOpen = false, children }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div style={styles.container}>
      <div style={styles.bar} onClick={() => setIsOpen(!isOpen)}>
        {icon}
        <span>{title}</span>
        {rightSlot}
        <img
          src={isOpen ? '/images/help/chevron_up_icon.svg' : '/images/help/chevron_down_icon.svg'}
          alt={isOpen ? 'chevron up' : 'chevron down'}
          style={styles.chevron}
        />
      </div>
      {isOpen && children}
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    marginTop: 12,
    marginBottom: 24
  },
  bar: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: 24,
    color: 'white',
    fontSize: 20,
    fontWeight: 700,
    lineHeight: '25px',
    background: '#292c35'
  },
  chevron: {
    marginLeft: 'auto'
  }
};

export default HelpAccordion;
